import { useIcon } from '~extension/icon-library/context/Icons';
import { Download } from './Download';
import { Info } from './Info';

export const Sidebar = () => {
  const { stageIcon } = useIcon();

  return (
    <div className="icon-library--sidebar w-1/4">
      <Info icon={stageIcon} />
      <div className="pt-4" />
      <Download icon={stageIcon} />
    </div>
  );
};
